export enum TransactionType {
  Commission = 'commission',
  FundingFee = 'fundingFee',
}

export enum TpslInputTypes {
  USDT = 'USDT',
  ROI = 'ROI',
}

export enum Tpsl {
  Profit = 'Profit',
  LoseCut = 'LoseCut',
}

export enum PriceType {
  LastPrice = 'Last Price',
  // IndexPrice = "Index Price",
  MarkPrice = 'Mark Price',
}

export enum OrderPriceType {
  Last = 'Last',
  Mark = 'Mark',
}

export enum MarginMode {
  CROSS = 'CROSS',
  ISOLATED = 'ISOLATED',
}

export enum LongShrot {
  LONG = 'LONG',
  SHORT = 'SHORT',
}

export enum SellBuy {
  BUY = 'BUY',
  SELL = 'SELL',
}

export enum OpenClose {
  OPEN = 'OPEN',
  CLOSE = 'CLOSE',
}

export enum WorkingType {
  CONTRACT_PRICE = 'CONTRACT_PRICE',
  MARK_PRICE = 'MARK_PRICE',
}

export enum ShowOrderMethod {
  LIMIT = 'Limit',
  MARKET = 'Market',
  STOP_LIMIT = 'Stop Limit',
  STOP_MARKET = 'Stop Market',
  TRAILING_STOP = 'Trailing Stop',
  POST_ONLY = 'Post Only',
}

export enum ConditionalType {
  STOP_LIMIT = 'STOP LIMIT',
  STOP_MARKET = 'STOP MARKET',
  TRAILING_STOP = 'TRAILING STOP',
  POST_ONLY = 'POST ONLY',
}

export enum QtyType {
  USDT = 'USDT',
  COIN = 'COIN',
}

export const ShowSTopMarketList: string[] = ['Stop Limit', 'Stop Market', 'Trailing Stop', 'Post Only']

export enum OrderMethod {
  LIMIT = 'LIMIT',
  MARKET = 'MARKET',
  STOP = 'STOP',
  STOP_LOSS = 'STOP_LOSS',
  TAKE_PROFIT = 'TAKE_PROFIT',
  STOP_LOSS_LIMIT = 'STOP_LOSS_LIMIT',
  TAKE_PROFIT_LIMIT = 'TAKE_PROFIT_LIMIT',
  LIMIT_MAKER = 'LIMIT_MAKER',
  TAKE_PROFIT_MARKET = 'TAKE_PROFIT_MARKET',
  STOP_MARKET = 'STOP_MARKET',
  TRAILING_STOP_MARKET = 'TRAILING_STOP_MARKET',
}

export enum Show_OrderMethod {
  LIMIT = 'LIMIT',
  MARKET = 'MARKET',
  STOP = 'STOP',
  STOP_LOSS = 'STOP LOSS',
  TAKE_PROFIT = 'TAKE PROFIT',
  STOP_LOSS_LIMIT = 'STOP LOSS LIMIT',
  TAKE_PROFIT_LIMIT = 'TAKE PROFIT LIMIT',
  LIMIT_MAKER = 'LIMIT MAKER',
  TAKE_PROFIT_MARKET = 'TAKE PROFIT MARKET',
  STOP_MARKET = 'STOP MARKET',
  TRAILING_STOP_MARKET = 'TRAILING STOP MARKET',
}

/*
GTC (Good Till Canceled): 주문이 거래가 체결되거나 사용자가 수동으로 취소할 때까지 유효합니다.
IOC (Immediate or Cancel): 주문이 즉시 실행 가능한 부분만 체결되고, 나머지는 즉시 취소됩니다. 부분 체결이 가능하지만 전부 체결되지 않는 경우 취소됩니다.
FOK (Fill or Kill): 주문이 즉시 전부 체결되거나, 전혀 체결되지 않고 취소됩니다. 부분 체결은 허용되지 않습니다.
GTX (Good Till Crossing): 지정된 가격이 교차할 때까지 유효하며, 교차 시 취소됩니다.
GTD (Good Till Date): 특정 날짜와 시간까지 유효하며, 지정된 시간이 지나면 자동으로 취소됩니다.
*/
export enum TimeInForce {
  GTC = 'GTC',
  IOC = 'IOC',
  FOK = 'FOK',
  GTX = 'GTX',
  GTD = 'GTD',
}

export const crosslist: string[] = ['cross', 'Cross', 'corssed', 'CROSS', 'CROSSED']
export const isolation: string[] = ['isolated', 'Isolated', 'Isolate', 'ISOLATE', 'ISOLATED']

///// GET, SET function LIST
export const setMarginType = (args: string | MarginMode) => {
  if (typeof args === 'string') {
    if (crosslist.includes(args)) {
      return MarginMode.CROSS
    }
    return MarginMode.ISOLATED
  }

  return args
}

// 변경 작업 처리
export const ChangePriceTypeToWorkingType = (args: PriceType) => {
  if (args === PriceType.LastPrice) {
    return WorkingType.CONTRACT_PRICE
  }
  return WorkingType.MARK_PRICE
}

// 리턴 작업 처리
export const ChangeWorkingTypeToPriceType = (args: WorkingType) => {
  if (args === WorkingType.CONTRACT_PRICE) {
    return PriceType.LastPrice
  }
  return PriceType.MarkPrice
}

//
export interface OrderbookData {
  price: string
  quantity: number
  total: number
  percentage: number
  sum: number
}
